import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { useHistory, useParams } from "react-router"
import {
  getAllCenters,
  getManagePaytmMerchantById,
  updatePaytmMerchant,
  addPaytmMerchant,
  getAllPaytmMerchants
} from "../../../../core/services/api"
import InputField from "../../../../components/InputField"
import Button from "../../../../components/Button"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
import Select from "react-select"
import Toast from "components/Toast"


function AddPaytmMerchant() {
  const history = useHistory()
  const readOnly = useSelector((state: any) => state?.user?.readOnly)
  const [isSubmit, setIsSubmit] = useState(false)
  const { id }: any = useParams()
  const [formErrors, setFormErrors] = useState<any>()
  const [centers, setCenters] = useState<any>([])
  const [centerOptions, setCenterOptions] = useState<any>([])
  const [success, setSuccess] = useState<boolean>(false)
  const [message, setMessage] = useState<string>("")
  const [allPaytmMerchants, setAllPaytmMerchants] = useState<any[]>([])
  const [toastType, setToastType] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [managePaytmMerchantInfo, setManagePaytmMerchantInfo] = useState<any>({
    id: "",
    centerId: "",
    centerName: "",
    merchantId: "",
    merchantKey: "",
    channelId: "",
    status: "",
    name: "",
  })
  const paytmMerchantStatus: string[] = ["ACTIVE", "INACTIVE"]
  const merchantStatus = paytmMerchantStatus.map((ele: any) => {
    return { label: ele, value: ele }
  })

  useEffect(() => {
    if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
      let test: any = {
        centerId: managePaytmMerchantInfo?.centerId,
        centerName: centers?.find((c: any) => c?.id === managePaytmMerchantInfo?.centerId)?.centerName,
        merchantId: managePaytmMerchantInfo?.merchantId,
        merchantKey: managePaytmMerchantInfo?.merchantKey,
        channelId: managePaytmMerchantInfo?.channelId,
        status: managePaytmMerchantInfo?.status,
        name: managePaytmMerchantInfo?.name?.trim(),
      }
      setIsLoading(true)
      if (!id) {
        addPaytmMerchant(test)
          .then((data) => {
            setIsLoading(false)
            setMessage("Paytm Merchant Created Successfully")
            setToastType("success")
            setSuccess(true)
          })
          .catch((err) => {
            setIsLoading(false)
            setMessage(err?.response?.data?.message)
            setToastType("error")
            setSuccess(true)
          })
      } else {
        updatePaytmMerchant(id, test)
          .then((data) => {
            setIsLoading(false)
            setMessage("Paytm Merchant Updated Successfully")
            setToastType("success")
            setSuccess(true)
          })
          .catch((err: any) => {
            setIsLoading(false)
            setMessage(err?.response?.data?.message)
            setToastType("error")
            setSuccess(true)
          })
      }
    }
  }, [formErrors])



  useEffect(() => {
    fetchManagePaytmMerchantById()
    fetchCentersDetails()
    fetchAllPaytmMerchants()
  }, [])

  const fetchManagePaytmMerchantById = () => {
    if (id && origin !== "Add") {
      getManagePaytmMerchantById(id)
        .then((res) => {
          setManagePaytmMerchantInfo({
            id: res?.id,
            centerId: res?.centerId,
            centerName: res?.centerName,
            merchantId: res.merchantId,
            merchantKey: res?.merchantKey,
            channelId: res?.channelId,
            status: res?.status,
            name: res?.name,
          })
        })
        .catch((err) => {
          console.log("Err,", err)
        })
    }
  }

  const fetchAllPaytmMerchants = () => {
    getAllPaytmMerchants()
      .then((res) => {
        setAllPaytmMerchants(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  const fetchCentersDetails = () => {
    getAllCenters().then((res: any) => {
      setCenters(res)
      const centerDetailsArray = res.map((c: any) => {
        return {
          label: `${c?.centerName}`,
          value: `${c?.id}`,
        }
      })
      setCenterOptions(centerDetailsArray)
    })
  }

  const validate = (values: any) => {
    const errors: any = {}

    if (!values?.centerId) {
      errors["centerId"] = "Center is required"
    }

    if (!values?.merchantId) {
      errors["merchantId"] = "Merchant ID is required"
    }

    if (!values?.merchantKey) {
      errors["merchantKey"] = "Merchant Key is required"
    }

    if (!values?.channelId) {
      errors["channelId"] = "Channel Id is required"
    }

    if (!values?.status) {
      errors["status"] = "Status is required"
    }

    if (!values?.name) {
      errors["name"] = "Merchant Name is required"
    }

    return errors
  }


  const handleSubmit = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    setFormErrors(validate(managePaytmMerchantInfo))
    setIsSubmit(true)
  }

  const assignedCenterIds = allPaytmMerchants.map(m => m?.centerId);

  const remainingCenters = centerOptions.filter((center: { value: any }) => !assignedCenterIds.includes(center.value)
  );

  return (
    <div className="edit-manage-staff-wrapper">
      {success ? (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => {
              setSuccess(false)
              if (toastType !== "error") {
                history.push(`/managePaytmMerchants`)
              }
            }}
            type={toastType}
          ></Toast></>
      ) : isLoading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      ) : (
        ""
      )}

      <div
        className="approval-back-image"
        onClick={() => {
          history.push("/managePaytmMerchants")
        }}
      >
        <img
          src={"../../../assets/images/back-icon.svg"}
          height={"60px"}
          width={"60px"}
          alt="back button"
          className="back_button"
        />
        <div className="edit-manage-staff-heading">{id ? `Edit Paytm Merchant` : `Add Paytm Merchant`}</div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="edit-details-wrapper">
          <div className="edit-details-container">
            {!id ? (
              <div className="edit-details-heading">Add Details</div>
            ) : (
              <div className="edit-details-heading">
                Edit Details - {managePaytmMerchantInfo?.name}
              </div>
            )}

            <div className="manage-staff-details">
              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">* Merchant Name:</label>
                </div>
                <InputField
                  className="col-md-8"
                  placeholder="Name"
                  readOnly={readOnly}
                  value={managePaytmMerchantInfo?.name}
                  handleChange={(e) => {
                    setManagePaytmMerchantInfo({
                      ...managePaytmMerchantInfo,
                      name: e.target.value,
                    })
                  }}
                  errorMsg={formErrors?.name}
                />
              </div>
              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">* Merchant ID:</label>
                </div>
                <InputField
                  className="col-md-8"
                  placeholder="Merchant ID"
                  readOnly={readOnly}
                  value={managePaytmMerchantInfo?.merchantId}
                  handleChange={(e) => {
                    setManagePaytmMerchantInfo({
                      ...managePaytmMerchantInfo,
                      merchantId: e.target.value,
                    })
                  }}
                  errorMsg={formErrors?.merchantId}
                />
              </div>
              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">* Merchant Key:</label>
                </div>
                <InputField
                  className="col-md-8"
                  placeholder="Merchant Key"
                  readOnly={readOnly}
                  value={managePaytmMerchantInfo?.merchantKey}
                  handleChange={(e) => {
                    setManagePaytmMerchantInfo({
                      ...managePaytmMerchantInfo,
                      merchantKey: e.target.value,
                    })
                  }}
                  errorMsg={formErrors?.merchantKey}
                />
              </div>

              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">* Channel Id:</label>
                </div>
                <InputField
                  className="col-md-8"
                  placeholder="Channel Id"
                  readOnly={readOnly}
                  value={managePaytmMerchantInfo?.channelId}
                  handleChange={(e) => {
                    setManagePaytmMerchantInfo({
                      ...managePaytmMerchantInfo,
                      channelId: e.target.value,
                    })
                  }}
                  errorMsg={formErrors?.channelId}
                />
              </div>

              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">* Center:</label>
                </div>
                <div className="col-md-8 patientIdContainer">
                  <Select
                    styles={customSelectStyles()}
                    value={centerOptions?.filter((p: any) => {
                      return p.value === managePaytmMerchantInfo?.centerId ? p.label : "";
                    })}
                    placeholder="Select center"
                    isSearchable={true}
                    options={centerOptions}
                    onChange={(option: any) => {
                      console.log("option", option)
                      setManagePaytmMerchantInfo({
                        ...managePaytmMerchantInfo,
                        centerId: option?.value,
                      })
                    }}
                  />
                  <span className="error-staff">{formErrors?.centerId}</span>
                </div>

              </div>

              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">* Status:</label>
                </div>
                <div className="col-md-8 statusContainer">
                  <Select
                    styles={customSelectStyles()}
                    value={merchantStatus.filter((p: any) => {
                      return p.value === managePaytmMerchantInfo?.status ? p.label : "";
                    })}
                    placeholder="Select status"
                    options={merchantStatus}
                    onChange={(option: any) => {
                      console.log("option", option)
                      setManagePaytmMerchantInfo({
                        ...managePaytmMerchantInfo,
                        status: option?.value,
                      })
                    }}
                  />
                  <span className="error-staff">{formErrors?.status}</span>
                </div>
              </div>
            </div>
            <div className="button-alignment">
              <div>
                <Button
                  text="Cancel"
                  type={"button"}
                  outline={true}
                  disabled={readOnly}
                  onClick={() => history.push(`/managePaytmMerchants`)}
                  id="cancel"
                />
              </div>

              <div>
                <Button
                  text={id ? "Update" : "Save"}
                  type="submit"
                  disabled={readOnly}
                  // onClick={handleSubmit}
                  id="save"
                />
              </div>

            </div>
          </div>
        </div>
      </form >
    </div>
  )
}
export default AddPaytmMerchant
